import { render, staticRenderFns } from "./sectionChild.vue?vue&type=template&id=56c964fc&"
import script from "./sectionChild.vue?vue&type=script&lang=js&"
export * from "./sectionChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports